const sx = {
  container: { display: 'flex', height: '100%', position: 'relative' },
  button: (orientation: string) => ({
    position: 'absolute',
    top: orientation === 'landscape' ? 32 : 'auto',
    bottom: orientation === 'portrait' ? 32 : 'auto',
    right: 32,
    zIndex: 1,
  }),
  img: {
    position: 'absolute',
    top: '50%',
    left: 0,
    width: '100%',
    maxHeight: '100%',
    transform: 'translateY(-50%)',
    borderRadius: '8px',
    cursor: 'pointer',
    objectFit: 'cover',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    backgroundColor: 'black',
    '&:hover': {
      border: '1px solid rgba(145, 158, 171, 0.5)',
    },
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default sx;
